<div class="container mt-5 mb-4 pb-3">
  <div class="row h-100">
    <div class="col-md-8 offset-md-2 col-12">
      <div class="right-section">
        <div class="right-section-content">
          <h1 class="title text-center">Member login</h1>

          <ngb-alert class="auth-alert" type="danger" *ngIf="errorMessage" (closed)="clearErrorMessage()">
            <div class="d-flex align-items-center">
              <span class="me-2">
                <img width="32" src={{invalidIcon}} alt="">
              </span> {{errorMessage}}
            </div>
          </ngb-alert>

          <div class="onboarding-card">
            <form [formGroup]="form" action="#" class="onboarding-form needs-validation" novalidate>
              <div class="d-flex flex-column gap-3">
                <div class="has-validation">
                  <label for="exampleInputEmail1" class="text-black font-17 pb-2">E-mail</label>

                  <input type="email" maxlength="255" formControlName="email" class="form-control vt-border bg-white"
                    [ngClass]="{ 'is-invalid': (form.get('email')?.touched && form.get('email')?.errors) }"
                    placeholder="Please enter your e-mail" id="exampleInputEmail1" aria-describedby="emailHelp" required>

                  <div class="invalid-feedback" *ngIf="(form.get('email')?.hasError('email') && form.get('email')?.touched) &&
                    !form.get('email')?.hasError('pattern')">
                    Invalid e-mail address
                  </div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('required')">E-mail is required</div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('pattern')  && form.get('email')?.touched">
                    Please enter a correct e-mail.
                  </div>
                </div>

                <div class="has-validation">
                  <label for="exampleInputPassword1" class="text-black font-17 pb-2">Password</label>

                  <div class="password-wrap">
                    <input type="{{ showPassword ? 'text' : 'password' }}" formControlName="password" placeholder="Password"
                      maxlength="255" class="form-control" [ngClass]="{ 'is-invalid': (form.get('password')?.touched &&
                      form.get('password')?.errors)  }" id="exampleInputPassword1" required>

                    <a class="show-password active text-black" href="#" (click)="togglePasswordVisibility($event)">{{showPassword ? 'Hide' : 'Show'}}
                    </a>

                    <div class="invalid-feedback" *ngIf="form.get('password')?.hasError('apiError') && form.get('password')?.touched">
                      {{errorMessage}}
                    </div>

                    <div class="invalid-feedback" *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched">
                      Password is required
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-3 align-items-center">
                  <button *ngIf="!loader" type="submit" class="btn-outlined position-relative login-btn" (click)="login(); trackButtonClick('Login')">
                    <span> Login </span>
                  </button>
                  <spinner *ngIf="loader"></spinner>

                  <div>
                    <a href="" routerLink="/reset/password" class="forgot-password" (click)="trackButtonClick('Forgot password')">
                      Forgot password?
                    </a>

                    <a class="ms-2 btn-lined" routerLink="/reset/password" (click)="trackButtonClick('Forgot password')" href="">
                      Reset now
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="rounded-10 bg-dark-green w-100 p-4 mt-4 pt-3">
        <div class="d-flex justify-content-between align-items-center gap-3 pb-3">
          <h3 class="mb-0 text-white">Don&apos;t have an account yet?</h3>
          <i class="icon-user_valid fs-1"></i>
        </div>

        <p class="mb-4 text-white w-md-90">
          Help us make sure you're getting the most relevant content by updating your professional details.
        </p>

        <button class="btn-outlined text-white" routerLink="/register" (click)="trackButtonClick('Register')">Sign-up</button>
      </div>
    </div>
  </div>
</div>
